import { cva, type VariantProps } from 'class-variance-authority';
import { uiMarker } from './shared';

/**
 * CONTROL SLOT
 *
 * A box a third party mounts its own field into — Stripe's card element,
 * which arrives as an iframe and can only be told where to go. The box is
 * drawn with Input's recipe so it lines up with the fields beside it; this
 * adds only what a mounted field needs from its host: a flex row, centred, so
 * the embedded control sits on the same baseline as a typed value would.
 */
export const controlSlotRecipe = cva([uiMarker, 'flex items-center'], {
  variants: {
    /** The embedded field may be as tall as it likes; the box grows with it. */
    grow: {
      true: 'h-auto min-h-control-md py-2',
      false: '',
    },
  },
  defaultVariants: { grow: false },
});

export type ControlSlotRecipeProps = VariantProps<typeof controlSlotRecipe>;
